/* HEADER SLIDERS START */

const slides = document.querySelectorAll(".header-slide");
const next = document.querySelector("#slideNext");
const prev = document.querySelector("#slidePrev");

// global variables scrolling
const auto = false;
const hasBtns = true;
const intervalTime = 10000; //ms
let slideInterval;

// set initial slide to 0
slides[0].classList.add("current");

// Indicator func
function indicatorSlide() {
  const indicator = document.querySelector(".header-buttons-indicator");
  // slides[0].classList.add('current')

  for (let i = 0; i < slides.length; i++) {
    const element = slides[i];

    // creates a dot for each slide
    const dot = document.createElement("span");
    dot.classList.add("indicator-dot");
    indicator.appendChild(dot);

    // when dot is clicked move to slide
    dot.addEventListener("click", () => {
      const current = document.querySelector(".current");
      current.classList.remove("current");
      element.classList.add("current");
    });
  }

  // adding functionality for dot styling
  const dots = document.querySelectorAll(".indicator-dot");
  dots[0].classList.add("indicator-dot-active");

  for (let i = 0; i < dots.length; i++) {
    const element = dots[i];

    // when dot element is click remove previous dot class and add new
    element.addEventListener("click", () => {
      const current = document.querySelector(".indicator-dot-active");
      current.classList.remove("indicator-dot-active");
      element.classList.add("indicator-dot-active");
    });
  }
}

// active indicator
function activeIndicator(x) {
  const dots = document.querySelectorAll(".indicator-dot");

  for (let i = 0; i < dots.length; i++) {
    const element = dots[i];
    element.classList.remove("indicator-dot-active");
    dots[x.id].classList.add("indicator-dot-active");
  }
}

// next slider btn
function nextSlide() {
  const current = document.querySelector(".current");
  const dots = document.querySelectorAll(".indicator-dot");

  if (current.nextElementSibling) {
    current.nextElementSibling.classList.add("current");
    activeIndicator(current.nextElementSibling);
  } else {
    slides[0].classList.add("current");
    dots[0].classList.add("indicator-dot-active");
    dots[slides.length - 1].classList.remove("indicator-dot-active");
  }
  setTimeout(() => current.classList.remove("current"));
}

// prev slider btn
function prevSlide() {
  const current = document.querySelector(".current");
  const dots = document.querySelectorAll(".indicator-dot");

  if (current.previousElementSibling) {
    current.previousElementSibling.classList.add("current");
    activeIndicator(current.previousElementSibling);
  } else {
    slides[slides.length - 1].classList.add("current");
    dots[slides.length - 1].classList.add("indicator-dot-active");
    dots[0].classList.remove("indicator-dot-active");
  }
  setTimeout(() => current.classList.remove("current"));
}

// if the slider has buttons
if (hasBtns) {
  next.addEventListener("click", (e) => {
    nextSlide();

    if (auto) {
      clearInterval(slideInterval);
      slideInterval = setInterval(nextSlide, intervalTime);
    }
  });
  prev.addEventListener("click", (e) => {
    prevSlide();
    clearInterval(slideInterval);
    slideInterval = setInterval(nextSlide, intervalTime);
  });
} else {
  next.style.display = "none";
  prev.style.display = "none";
}

if (slides.length > 1) {
  indicatorSlide();
}

// auto slider
if (auto) {
  // document.querySelector('.header-buttons').style.display = "none"
  slideInterval = setInterval(nextSlide, intervalTime);
}

/* HEADER SLIDER END */
